export const paytypeGroup = [
    { code: 'PENDING', name: 'NONE' },
    { code: 'INVOICE', name: 'CARD_NEW' },
    { code: 'JP_SMBC', name: 'CARD_NEW' },
    { code: 'JP_RESONA', name: 'CARD_NEW' },
    { code: 'BANK_SMBC', name: 'CARD_NEW' },
    { code: 'BANK_RESONA', name: 'CARD_NEW' },
    { code: 'CARD', name: 'CARD_UPDATE' },
    { code: 'NTTE', name: 'CARD_NEW' },
    { code: 'NTTW', name: 'CARD_NEW' },
    { code: 'NTTO', name: 'CARD_NEW' },
    { code: 'SUPER', name: 'NONE' },
    { code: 'MERGED', name: 'NONE' },
    { code: 'OEM', name: 'NONE' },
    { code: 'PAYMENT_INVALID', name: 'CARD_UPDATE' }
];
